let config = {
	remoteLogging: false,
	lumberjackLocation: 'wss://lj.viciswap.io/lumberjack/ws',
	cbpath: 'https://cbp.viciswap.io/api/v3/brokerage/',
	minToCoinVolume: 10000,
	promiseAllTimeout: 60000,
	swapChecks : 2,
	//overAskBidMultiplier: 0.00005, //1/2 BIP over ask /Under bid
	overAskBidMultiplier: 0.0001, //1 BIP
	chains:{
		// 1: {
		// 	name: 'Ethereum',
		// 	rpc: 'https://mainnet.gateway.tenderly.co',
		// 	vcntAddress: '0x3bE775B699fee916E7De117994358fF8F48e4569',
		// 	image:'img/eth.png',
		// },
		10: {
			name: 'Optimism',
			rpc: 'https://mainnet.optimism.io',
			vcntAddress: '0xc6bdfc4f2e90196738873e824a9efa03f7c64176',
			image:'img/optimism.png',
		},
		// 56: {
		// 	name: 'BNB Smart Chain',
		// 	rpc: 'https://bsc-dataseed1.binance.org/',
		// 	vcntAddress: '0xc6bdfc4f2e90196738873e824a9efa03f7c64176',
		// 	image:'img/bsc.png',
		// },
		137: {
			name: 'Polygon',
			rpc: 'https://polygon-rpc.com',
			vcntAddress: '0x8a16D4bF8A0a716017e8D2262c4aC32927797a2F',
			image:'img/polygon.png',
		},
		8453: {
			name: 'Base',
			rpc: 'https://mainnet.base.org',
			vcntAddress: '0xdcf5130274753c8050ab061b1a1dcbf583f5bfd0',
			image:'img/base.png',
		},
		42161: {
			name: 'Arbitrum One',
			rpc: 'https://arb1.arbitrum.io/rpc',
			vcntAddress: '0x60bf4E7cF16Ff34513514b968483B54Beff42a81',
			image:'img/arbitrum.png',
		},
		// 43114: {
		// 	name: 'Avalanche C-Chain',
		// 	rpc: 'https://api.avax.network/ext/bc/C/rpc',
		// 	vcntAddress: '0xc6BDFC4f2E90196738873E824a9eFa03F7c64176',
		// 	image:'img/avalanche.png',
		// },
	},
}
export default config;